module.exports = __webpack_public_path__ + "static/media/pelumi.b2c211ae.png";